<template>
  <v-dialog v-model="showVideo" persistent max-width="1000">
    <v-card>
      <div class="text-xs-right">
        <v-btn
          flat
          fab
          dark
          small
          color="grey"
          @click="$emit('input', false)"
          style="line-height: 10px"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-tabs v-model="active" slider-color="primary">
        <v-tab :key="'facebook'" :href="'#facebook'" ripple>Facebook</v-tab>
        <v-tab :key="'url'" :href="'#url'" ripple>{{ $t('Link') }}</v-tab>
        <v-tab :key="'richvideo'" :href="'#richvideo'" ripple>{{ $t('LINE RICH VIDEO') }}</v-tab>
        <template v-if="selectedBot && ['summithr'].includes(selectedBot.type)">
          <v-tab :key="'uplaod'" :href="'#upload'" ripple>{{ $t('Upload') }}</v-tab>
        </template>
      </v-tabs>
      <v-card-text>
        <v-flex xs12 class="form-control pa-1">
          <div class="caption">Notify</div>
          <input
            type="text"
            placeholder="You receive message"
            v-model.lazy="notify"
            class="form-control"
            maxlength="255"
          />
        </v-flex>
        <div v-if="active == 'facebook'">
          <video-list @onSelect="addVideo"></video-list>
        </div>
        <div v-else-if="active == 'url'">
          <div class="caption">{{ $t('Link') }}</div>
          <div class="form-control" :class="{ 'has-error': errors.has('videourl') }">
            <textarea
              style="min-height: 90px"
              :placeholder="$t('Link')"
              data-vv-name="videourl"
              :data-vv-as="$t('Link')"
              v-model="videourl"
              v-validate="
                active == 'url'
                  ? {
                      required: true,
                      regex: /(\.(mp4)$|^(https:\/\/drive\.google\.com\/uc))/,
                      isUrl: true
                    }
                  : ''
              "
            ></textarea>
            <span class="text-error" v-show="errors.has('videourl')">{{
              errors.first('videourl')
            }}</span>
          </div>

          <div class="text-xs-center">
            <v-btn depressed color="primary" @click="addVideo">{{ $t('Select') }}</v-btn>
          </div>
        </div>
        <div v-if="active == 'richvideo'">
          <div class="flex-all-center">
            <video v-if="videourl" id="video-element" width="60%" controls crossorigin="anonymous">
              <source :src="videourl" type="video/mp4" />
            </video>
          </div>
          <div class="caption">{{ $t('Link') }}</div>
          <div class="form-control" :class="{ 'has-error': errors.has('videourl') }">
            <textarea
              style="min-height: 90px"
              :placeholder="$t('Link')"
              data-vv-name="videourl"
              :data-vv-as="$t('Link')"
              v-model="videourl"
              v-validate="
                active == 'url'
                  ? {
                      required: true,
                      regex: /(\.(mp4)$|^(https:\/\/drive\.google\.com\/uc))/,
                      isUrl: true
                    }
                  : ''
              "
              @blur="handleBlurLink"
            />
            <span class="text-error" v-show="errors.has('videourl')">{{
              errors.first('videourl')
            }}</span>
          </div>

          <div v-if="showAdjustSize">
            <div class="primary--text">กรุณาเลือกรูปปกวิดีโอที่ขาดเท่ากับวิดีโอ</div>
            <uploadfile
              :data-vv-as="$t('Preview video')"
              ref="answer"
              v-model="video_preview_url"
              :data-vv-name="'photo'"
              v-validate="'required'"
            >
              <v-btn small color="primary">
                <v-icon small class="mr-1">camera_alt</v-icon> Upload Preview Video
              </v-btn>
            </uploadfile>

            <span class="text-error error--text caption" v-if="errors.has('photo')">{{
              errors.first('photo')
            }}</span>
          </div>

          <div class="text-xs-center">
            <v-btn :loading="loading" depressed color="primary" @click="addVideo">{{
              $t('Select')
            }}</v-btn>
          </div>
        </div>
        <div v-if="active == 'upload'">
          <UploadVideo2 @onUploaded="onUploaded" :pageid="selectedBot.pageid" />

          <div class="text-xs-center">
            <v-btn :loading="loading" depressed color="primary" @click="addVideo">{{
              $t('Select')
            }}</v-btn>
          </div>
        </div>

        <div class="mt-4 caption">
          {{
            $t(
              'Note: Large video files are slow to download , it can cause a failure and file type must be .mp4'
            )
          }}
        </div>
        <div class="caption">{{ $t('moreover recommend file size = 25MB') }}</div>
      </v-card-text>
      <div class="mt-5" style="display: none">
        <div id="preview"></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoList from './VideoList'
import api from '@/api'
import UploadVideo2 from '@/components/elements/UploadVideo2.vue'
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value'],
  data: function () {
    return {
      showVideo: this.value,
      loading: false,
      active: 'facebook',
      videourl: null,
      notify: null,
      showAdjustSize: false,
      videoSize: {
        width: 1040,
        height: 1040
      },
      video_preview_url: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    VideoList,
    UploadVideo2,
    uploadfile
  },
  methods: {
    onUploaded(videoUrl) {
      this.videourl = videoUrl
    },
    async handleBlurLink() {
      const _VIDEO = document.querySelector('#video-element')
      await this.$nextTick()
      if (_VIDEO && _VIDEO.videoWidth == 0 && _VIDEO.videoHeight == 0) {
        this.showAdjustSize = true
      } else {
        this.showAdjustSize = false
      }
    },
    loadImage(objectUrl) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = function () {
          resolve({
            width: this.width,
            height: this.height
          })
        }
        img.src = objectUrl
      })
    },
    addVideo: async function (video) {
      const vm = this
      vm.loading = true
      const _VIDEO = document.querySelector('#video-element')
      await this.$nextTick()
      vm.$validator.validate().then(async (result) => {
        if (!result) {
          // do stuff if not valid.

          vm.goToErrorInput()
          vm.loading = false
          return false
        }

        let url = null,
          w = 0,
          h = 0
        if (_VIDEO && _VIDEO.videoWidth != 0 && _VIDEO.videoHeight != 0) {
          const canvas = document.createElement('canvas')
          canvas.setAttribute('width', _VIDEO.videoWidth)
          canvas.setAttribute('height', _VIDEO.videoHeight)
          canvas.setAttribute('crossorigin', 'anonymous')
          const ctx = canvas.getContext('2d')
          ctx.drawImage(_VIDEO, 0, 0, _VIDEO.videoWidth, _VIDEO.videoHeight)
          document.getElementById('preview').appendChild(canvas)
          let img = canvas.toDataURL('image/png')
          let blobBin = atob(img.split(',')[1])

          const my_array = []
          for (let i = 0; i < blobBin.length; i++) {
            my_array.push(blobBin.charCodeAt(i))
          }
          const file = new Blob([new Uint8Array(my_array)], { type: 'image/png' })

          url = await vm.upload(
            file,
            vm.videourl
              .split(/(\\|\/)/g)
              .pop()
              .split('.')[0]
          )

          w = _VIDEO && _VIDEO.videoWidth
          h = _VIDEO && _VIDEO.videoHeight
        } else {
          if (vm.video_preview_url) {
            const videoSize = await vm.loadImage(vm.video_preview_url)
            url = vm.video_preview_url
            vm.videoSize = videoSize
            w = vm.videoSize.width
            h = vm.videoSize.height
          }
        }
        const r = h / w
        h = 1040 * r

        vm.loading = false

        if (vm.active == 'facebook') {
          vm.$emit('onAddVideo', {
            source: 'https://www.facebook.com' + video.permalink_url,
            picture: video.picture,
            type: 'video',
            sourceline: video.source
          })
        } else if (vm.active == 'url') {
          vm.$emit('onAddVideo', {
            source: vm.videourl,
            picture: null,
            type: 'video',
            sourceline: vm.videourl
          })
        } else if (['richvideo', 'upload'].includes(vm.active)) {
          let data = {
            type: 'imagemap',
            baseUrl: url + '?_ignored=',
            altText: vm.notify ? vm.notify : 'You receive message',
            is_rich_video: true,
            baseSize: {
              width: 1040,
              height: h
            },
            video: {
              originalContentUrl: vm.videourl,
              ...(url ? { previewImageUrl: url + '?_ignored=' } : {}),
              area: {
                x: 0,
                y: 0,
                width: 1040,
                height: h
              }
            },
            actions: [
              {
                type: 'uri',
                linkUri: vm.videourl,
                area: {
                  x: 0,
                  y: 0,
                  width: 1,
                  height: 1
                }
              }
            ]
          }
          console.log(data)
          vm.$emit('onAddVideo', data)
        }
      })
    },
    upload(file, name) {
      let data = {
        name: name + '.png',
        type: 'image/png',
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          vm.loading = false
          vm.$emit('input', vm.currentImage)
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(url)
        })
      })
    }
  },
  watch: {
    value: function (newVal) {
      this.showVideo = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/ModalVideo.vue